import { render, staticRenderFns } from "./comments.vue?vue&type=template&id=a69853b8&"
import script from "./comments.vue?vue&type=script&lang=js&"
export * from "./comments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a69853b8')) {
      api.createRecord('a69853b8', component.options)
    } else {
      api.reload('a69853b8', component.options)
    }
    module.hot.accept("./comments.vue?vue&type=template&id=a69853b8&", function () {
      api.rerender('a69853b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/comments.vue"
export default component.exports